export default "__VITE_ASSET__0b290105__"